import {createSlice} from '@reduxjs/toolkit'
import {MPersonDetailGraphEntity} from 'app/modules/discovery/core/_models'
import {IUserFE} from 'interfaces/IUserFE'
import {fetchUser, updateUserAsncThunk} from 'redux/actions/userActions'

export interface UserState {
  user: IUserFE | undefined
  personClaims: MPersonDetailGraphEntity[] | undefined
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: UserState = {
  user: undefined,
  personClaims: undefined,
  status: 'idle',
  error: null,
}

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    clearUser: (state) => {
      state.user = undefined
    },
    setPersonsClaimed: (state, action) => {
      if (action.payload) {
        state.personClaims = action.payload
      } else {
        state.personClaims = []
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.status = 'succeeded'
        if (action.payload) {
          // @ts-ignore
          state.user = action.payload
        }
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload as string
      })
      .addCase(updateUserAsncThunk.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(updateUserAsncThunk.fulfilled, (state, action) => {
        state.status = 'succeeded'
        if (action.payload) {
          // @ts-ignore
          state.user = action.payload
        }
      })
      .addCase(updateUserAsncThunk.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload as string
      })
    // .addMatcher(apiSlice.endpoints.getUser.matchFulfilled, (state, action) => {
    //   state.status = 'succeeded'
    //   if (action.payload) {
    //     // @ts-ignore
    //     state.user = action.payload
    //   }
    // })
    // .addMatcher(apiSlice.endpoints.getUser.matchRejected, (state, action) => {
    //   state.status = 'failed'
    //   state.error = action.payload as unknown as string
    // })
    // .addMatcher(apiSlice.endpoints.getUser.matchPending, (state) => {
    //   state.status = 'loading'
    // })
  },
})

export const {clearUser, setPersonsClaimed} = userSlice.actions
export default userSlice.reducer
